<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" (click)="windowClick()">
  <dialog-header [label]="'Channels To Ztube (' + channels.length + ')'" [dialogRef]='dialogRef' (mousedown)="windowClick()" [object]='this'>
  </dialog-header>
  <mat-button-toggle-group [(ngModel)]="channelFilter" class="channel-filter">
    <mat-button-toggle value="all">הכל</mat-button-toggle>
    <mat-button-toggle value="fixed">קבועות</mat-button-toggle>
    <mat-button-toggle value="dynamic">דינמיות</mat-button-toggle>
  </mat-button-toggle-group>
  <div class="scroll-container">
    <div *ngFor="let ent of filteredChannels" class="row">
      <div class="cell status-icon" *ngIf="ent.camera" [matTooltip]="getConnectionStatusTooltip(ent.camera)">
        <mat-icon [ngClass]="getConnectionStatusColor(ent.camera)">lens</mat-icon>
      </div>
      <div class="cell channel">
        {{ ent.channel }}
      </div>
      <div *ngIf="ent.camera"  class="cell camera-info">
        <div>{{ ent.camera.cameraName }}</div>
      </div>
      <div class="cell buttons">
        <button class="small-button" mat-stroked-button (click)="setCenter(ent.camera.cameraStreamName,ent.camera.activeStreamName)"
          [matTooltip]="'Center Camera'" [disabled]="!ent.camera">
          <mat-icon class="svg-icon">place</mat-icon>
        </button>
        <button class="small-button" mat-stroked-button (click)="openAro(ent.camera.cameraStreamName)"
          [matTooltip]="'Open Camera ARO'" [disabled]="!ent.camera">
          <mat-icon class="svg-icon">assignment</mat-icon>
        </button>
        <button class="small-button" mat-stroked-button (click)="removeCamera(ent.camera.cameraStreamName,ent.camera.activeStreamName)"
          [matTooltip]="'Remove'">
          <mat-icon class="svg-icon">delete</mat-icon>
        </button>
        <mat-icon class="svg-icon" [matTooltip]="ent.camera ? ('Set by: ' + ent.camera.lastUpdateUser + ' At: ' + ent.camera.lastUpdateDate) : ('')" style="align-self: center">
          info
        </mat-icon>
      </div>
    </div>
  </div>
</div>